import { render, staticRenderFns } from "./UserIntegralGet.vue?vue&type=template&id=2ad6bf46&scoped=true&"
import script from "./UserIntegralGet.vue?vue&type=script&lang=js&"
export * from "./UserIntegralGet.vue?vue&type=script&lang=js&"
import style0 from "./UserIntegralGet.vue?vue&type=style&index=0&id=2ad6bf46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6bf46",
  null
  
)

export default component.exports